// Module
var code = "<md-switch class=\"md-primary\"></md-switch>";
// Exports
module.exports = code;